import React from "react";
import { MenuItem } from "./DocumentationMenuNode";
import Introduction from "./sections/api/Introduction";
import DefaultConfig from "./sections/api/DefaultConfig";
import CallProFile from "./sections/api/CallProFile";
import UseProFile from "./sections/api/UseProFile";
import ReactExampleCode from "./sections/api/ReactExampleCode";
import miniGuides from "./sections/api/miniGuides";
import ProcessProfileResult from "./sections/api/ProcessProfileResult";
import MinibeakConfig from "./sections/api/MinibeakConfig";
import MinibeakResult from "./sections/api/MinibeakResult";
import MinibeakHookResult from "./sections/api/MinibeakHookResult";
import ClearCallCache from "./sections/api/ClearCallCache";
import TypescriptAndCasting from "./sections/api/TypescriptAndCasting";

export const docSections: Array<MenuItem> = [
  {
    name: "Introduction",
    content: <Introduction />,
    noHeader: true,
  },
  {
    name: "React example code",
    content: <ReactExampleCode />,
    noHeader: true,
  },
  {
    name: "API",

    children: [
      {
        name: "defaultConfig",
        description: "Holds default request options",
        content: <DefaultConfig />,
      },
      {
        name: "useProFile",
        description: "Fetches data from ProFile",
        content: <UseProFile />,
      },
      {
        name: "callProFile",
        description: "Performs calls against ProFile",
        content: <CallProFile />,
      },
      {
        name: "processProFileResult",
        description: "Crates links between returned resources",
        content: <ProcessProfileResult />,
      },
      {
        name: "clearCallCache",
        description: "Clears the call cache",
        content: <ClearCallCache />,
      },
    ],
  },
  {
    name: "Types",
    children: [
      {
        name: "MinibeakConfig",
        description: "Specifies ProFile call parameters",
        content: <MinibeakConfig />,
      },
      {
        name: "MinibeakResult",
        description: "Contains the result of a processProFileResult call",
        content: <MinibeakResult />,
      },
      {
        name: "MinibeakHookResult",
        description: "Contains the result and state of a useProFile call",
        content: <MinibeakHookResult />,
      },
      {
        name: "TypesScript and casting",
        description: "How to type the returned resources",
        content: <TypescriptAndCasting />,
      },
    ],
  },
  {
    name: "Errors",
    children: [
      {
        name: "ResponseNotOkError",
        description: "Response status code not in 200-series",
        content: (
          <>
            <p>
              Thrown when the http response has a status code not in the
              200-series. For example, when authentication failed, access was
              denied, or the resource did not exist.
            </p>
            <p>
              This error has a <code>.response</code> field containing the
              response.
            </p>
          </>
        ),
      },
    ],
  },

  miniGuides,
];
